import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { AnimatePresence, motion } from 'framer-motion';
import numbro from 'numbro';

import { Icons, IconType } from '../../../constants/icons';
import { Profile, XpLevel } from '../../../models/UserStore';
import { AnimatedNumber, AnimatedNumberProps } from '../../Templates/Game';
import { AvatarNode } from '../AvatarNode';
import { LightSwipe } from '../LightSwipe';

import './AchievementInfoCell.css';

export type AchievementInfoCellProps = {
  userProfile: Profile;
  level: number;
  progress: number;
  currentExp: number;
  totalExp: number;
  socialExp: number;
  knowledgeExp: number;
  addExpAnimation?: AnimatedNumberProps;
  isDisplayName?: boolean;
  isDisableBg?: boolean;
  isPlayingAnimation?: boolean;
  isBrainIcon?: boolean;
};
// it seems that this page is only used by game end template
export const AchievementInfoCell = memo((props: AchievementInfoCellProps) => {
  const {
    userProfile,
    level,
    // progress,
    currentExp,
    // totalExp,
    addExpAnimation,
    // isDisplayName,
    isDisableBg,
    isPlayingAnimation,
    isBrainIcon,
  } = props;
  const { t } = useTranslation();

  const localProgress = useMemo(() => {
    return XpLevel.getProgress(currentExp);
  }, [currentExp]);

  const localLevel = useMemo(() => {
    return XpLevel.getLevel(currentExp);
  }, [currentExp]);

  return (
    <div className="achievement-info-cell">
      <div className="centered-container">
        <div className={`${'upper'} ${isDisableBg ? '' : 'white-bg'}`}>
          <div className="club-icon-container">
            <AnimatePresence mode="sync">
              {isBrainIcon ? (
                <motion.img
                  key="brain"
                  initial={{ opacity: 1, width: 80, height: 80 }}
                  animate={{
                    opacity: 1,
                    width: isPlayingAnimation ? 95 : 80,
                    height: isPlayingAnimation ? 95 : 80,
                  }}
                  exit={{ opacity: 0, width: 80, height: 80 }}
                  transition={{
                    duration: 0.3,
                    ease: 'easeInOut',
                  }}
                  src={Icons[IconType.BrainGameEnd]}
                  style={{ backgroundColor: '#fff', borderRadius: '9999px' }}
                />
              ) : (
                <motion.div
                  key="avatar"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{
                    duration: 0.3,
                    ease: 'easeInOut',
                  }}
                >
                  <AvatarNode profile={userProfile} size={80} />
                </motion.div>
              )}
            </AnimatePresence>
          </div>
          <div className="exp-info">
            <div className="title">{t('Wisdom Level')}</div>
            <div className="bar-container">
              <div className="black-layer-text">{`Lv.${localLevel}`}</div>
              <div
                className={`${'progress-bar'} ${isDisableBg ? 'white-bg' : ''}`}
              >
                <motion.div
                  key={localLevel}
                  className="progress"
                  style={{ width: `${localProgress * 100}%` }}
                  animate={{
                    width: `${localProgress * 100}%`,
                  }}
                  transition={{
                    duration: 0.3,
                    ease: 'easeInOut',
                  }}
                >
                  <LightSwipe height={12} />
                </motion.div>
              </div>
            </div>
            <div className="exp-bar">
              {/* <span className="normal-text">{t('Total: ')}</span> */}
              <p>{t('Total: ')}</p>
              <span className="bold-text" style={{ color: '#298D92' }}>
                <AnimatePresence mode="wait">
                  <motion.span
                    key={currentExp}
                    // initial={{ scale: 1.5, opacity: 0 }}
                    // animate={{ scale: 1, opacity: 1 }}
                    // transition={{ duration: 0.5 }}
                    className="bold-text"
                    style={{ color: '#298D92' }}
                  >
                    {numbro(currentExp).format({
                      thousandSeparated: true,
                    })}
                  </motion.span>
                </AnimatePresence>
                {addExpAnimation && <AnimatedNumber {...addExpAnimation} />}
              </span>
              <p>{t('Wisdom XP')}</p>
              {/* <span className="normal-text">
                {` / ${numbro(totalExp).format({
                  thousandSeparated: true,
                })} XP`}
              </span> */}
            </div>
          </div>
        </div>
        {/* <div className="lower">
          <div className="exp-cell">
            <img className="exp-icon" src={Icons[IconType.SocialExp]} />
            <div className="exp-text-container">
              <div className="exp-name">{t('JOY Contribution')}</div>
              <div className="exp-text">{`${numbro(socialExp).format({
                thousandSeparated: true,
              })} XP`}</div>
            </div>
            <SvgIcon name={SVGIconType.Arrow} className={'arrow-icon'} />
          </div>
          <div className="divider" />
          <div className="exp-cell">
            <img className="exp-icon" src={Icons[IconType.KnowledgeExp]} />
            <div className="exp-text-container">
              <div className="exp-name">{t('Knowledge')}</div>
              <div className="exp-text">{`${numbro(knowledgeExp).format({
                thousandSeparated: true,
              })} XP`}</div>
            </div>
            <SvgIcon name={SVGIconType.Arrow} className={'arrow-icon'} />
          </div>
        </div> */}
      </div>
    </div>
  );
});
